import { render } from "./A01PointNotificationPanelThanksOnlyPoint.vue?vue&type=template&id=1e770e75&scoped=true&ts=true"
import script from "./A01PointNotificationPanelThanksOnlyPoint.vue?vue&type=script&lang=ts"
export * from "./A01PointNotificationPanelThanksOnlyPoint.vue?vue&type=script&lang=ts"

import "./A01PointNotificationPanelThanksOnlyPoint.vue?vue&type=style&index=0&id=1e770e75&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e770e75"]])

export default __exports__